import { combineReducers } from 'redux'
import {
  getEmailsListRoutine,
  getEmailStatsRoutine,
  getEmailDetailsRoutine,
  markEmailAsReadRoutine,
  retryEmailAttachmentsRoutine,
  retryEmailAttachmentRoutine
} from './actions'

const initialEmailsState = {
  items: [],
  meta: {
    current_page: 1,
    last_page: 1,
    per_page: 20,
    total: 0
  },
  loading: false,
  error: null
}

const initialStatsState = {
  data: {
    total_emails: 0,
    unread_emails: 0,
    total_attachments: 0,
    processed_attachments: 0,
    failed_attachments: 0
  },
  loading: false,
  error: null
}

const initialEmailDetailState = {
  data: null,
  loading: false,
  error: null
}

const initialActionsState = {
  markingAsRead: {},
  retryingAttachments: {},
  retryingAttachment: {}
}

const emails = (state = initialEmailsState, action) => {
  switch (action.type) {
    case getEmailsListRoutine.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case getEmailsListRoutine.SUCCESS:
      const { emails: newEmails, meta, append } = action.payload
      return {
        ...state,
        loading: false,
        items: append ? [...state.items, ...newEmails] : newEmails,
        meta,
        error: null
      }

    case getEmailsListRoutine.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case markEmailAsReadRoutine.SUCCESS:
      const emailId = action.payload
      return {
        ...state,
        items: state.items.map(email => 
          email.id === emailId 
            ? { 
                ...email, 
                isReadByMe: true,
                readCount: (email.readCount || 0) + 1
              }
            : email
        )
      }

    default:
      return state
  }
}

const stats = (state = initialStatsState, action) => {
  switch (action.type) {
    case getEmailStatsRoutine.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case getEmailStatsRoutine.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      }

    case getEmailStatsRoutine.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    default:
      return state
  }
}

const emailDetail = (state = initialEmailDetailState, action) => {
  switch (action.type) {
    case getEmailDetailsRoutine.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case getEmailDetailsRoutine.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      }

    case getEmailDetailsRoutine.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case markEmailAsReadRoutine.SUCCESS:
      // Update the email detail if it's the same email that was marked as read
      if (state.data && state.data.id === action.payload) {
        return {
          ...state,
          data: {
            ...state.data,
            isReadByMe: true,
            readCount: (state.data.readCount || 0) + 1
          }
        }
      }
      return state

    default:
      return state
  }
}

const actions = (state = initialActionsState, action) => {
  switch (action.type) {
    case markEmailAsReadRoutine.REQUEST:
      return {
        ...state,
        markingAsRead: {
          ...state.markingAsRead,
          [action.payload.emailId]: true
        }
      }

    case markEmailAsReadRoutine.SUCCESS:
    case markEmailAsReadRoutine.FAILURE:
      const emailId = action.payload?.emailId || action.payload
      return {
        ...state,
        markingAsRead: {
          ...state.markingAsRead,
          [emailId]: false
        }
      }

    case retryEmailAttachmentsRoutine.REQUEST:
      return {
        ...state,
        retryingAttachments: {
          ...state.retryingAttachments,
          [action.payload.emailId]: true
        }
      }

    case retryEmailAttachmentsRoutine.SUCCESS:
    case retryEmailAttachmentsRoutine.FAILURE:
      return {
        ...state,
        retryingAttachments: {
          ...state.retryingAttachments,
          [action.payload]: false
        }
      }

    case retryEmailAttachmentRoutine.REQUEST:
      return {
        ...state,
        retryingAttachment: {
          ...state.retryingAttachment,
          [action.payload.attachmentId]: true
        }
      }

    case retryEmailAttachmentRoutine.SUCCESS:
    case retryEmailAttachmentRoutine.FAILURE:
      return {
        ...state,
        retryingAttachment: {
          ...state.retryingAttachment,
          [action.payload.attachmentId]: false
        }
      }

    default:
      return state
  }
}

export default combineReducers({
  emails,
  emailDetail,
  stats,
  actions
})